import { Accessor, createEffect, createSignal, onCleanup } from "solid-js"

export function createSignalFromExternalStore<T>(initial: () => T, subscribe: (cb: (value: T) => void) => () => void): Accessor<T | undefined> {
	const [value, setValue] = createSignal<T>(initial())

	createEffect(() => {
		const unsubscribe = subscribe(setValue)
		onCleanup(unsubscribe)
	})

	return value
}
